// extracted by mini-css-extract-plugin
module.exports = {"labels":"_9330de7794--labels--w3ZgM","label-item":"_9330de7794--label-item--DegjK","label":"_9330de7794--label--VulBy"};